import { render, staticRenderFns } from "./ModalAlterarSituacaoLoteEItem.vue?vue&type=template&id=fdde2088&scoped=true"
import script from "./ModalAlterarSituacaoLoteEItem.vue?vue&type=script&lang=js"
export * from "./ModalAlterarSituacaoLoteEItem.vue?vue&type=script&lang=js"
import style0 from "./ModalAlterarSituacaoLoteEItem.vue?vue&type=style&index=0&id=fdde2088&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdde2088",
  null
  
)

export default component.exports